import React, { useRef } from 'react'
import classNames from 'classnames'
import { message } from 'antd'
import Input from '../../../baseComponent/input'
import Textarea from '../../textarea'
import link from '../../../utils/link'
import { PLATFORM_VALUE } from '../../platformConfig'
import './index.less'
import InsList from './insList'
import TagLists from '../../imageDetail/tagSelection'
import Sku from './sku'
import ImageCardDisplay from '../imageCardDisplay'
import { MODES } from '../enum'

const QUERY_TYPE = { ALL: 3, COOP: 2, MY: 1, COMPLETE: 4 }

export default ({
  imageNum,
  imageGroupEntityId,
  platformId,
  itemDataDTO,
  dyItemDataDTO,
  userInfo,
  source,
  nickName,
  text,
  visibleWhalePick,
  tags,
  description,
  mode,
  setState,
  setMode,
  onClose,
  onChangeMainImage,
  onAddTag,
  onDeleteTag,
  onJoin,
  currentViewBlog,
  fetchIdeaMassList,
  mainUrl,
  skuImage,
  picUrl,
  queryType,
  onChangeTab,
  keyWords,
  inspirationGroups,
  onCreateInspiration,
  beforeJoin,
  loading,
  isEnd,
  batchSelected,
  start,
  options,
}) => {
  const imageCardRef = useRef(null)
  const _onCreateInspiration = (...arg) => {
    if (imageCardRef.current.images?.length === 0) {
      message.info('请选择图片')
      return
    }
    onCreateInspiration?.(...arg, imageCardRef.current.images)
  }
  const _beforeJoin = (...arg) => {
    if (imageCardRef.current.images?.length === 0) {
      message.info('请选择图片')
      return
    }
    beforeJoin?.(...arg, imageCardRef.current.images)
  }
  return <div className="mn-add-into-idea-mass-modal" onClick={e => e && e.stopPropagation()}>
    <div className="info">
      <ImageCardDisplay
        imageNum={imageNum}
        blogId={imageGroupEntityId}
        platformId={platformId}
        mode={mode}
        skuImage={skuImage}
        picUrl={picUrl}
        mainUrl={mainUrl}
        ref={imageCardRef}
      />
      {/*  || platformId == PLATFORM_VALUE.CROSSBORDER */}
      {(platformId == PLATFORM_VALUE.ITEM || platformId == PLATFORM_VALUE.DY)
        ? <ItemInfo {...itemDataDTO} {...dyItemDataDTO} imageGroupEntityId={imageGroupEntityId} {...options} userInfo={userInfo} />
        : <div className="ins-add-inspiration-info-wrapper">
          {(source || nickName) ? <div className="info-title">
            {source && <span>来自&ensp;{source}</span> }
            <span style={{ color: 'var(--m-text-1)', display: nickName ? 'inline-block' : 'none' }}>by&nbsp;{nickName}</span>
          </div> : null}
          <div className="info-detail"> {text} </div>
        </div>}
      {!visibleWhalePick && <TagLists type="fetchInterface" value={tags} onChange={val => setState({ tags: val })} suffix={20} style={{ width: '100%' }} closeFold className="ins-add-inspiration-info-tag-lists" />}
      <Textarea
        wrapClassName="mn-add-inspiration-create-comment"
        placeholder="输入内容，来让自己或其他成员更好的了解款式的面料，辅料、工艺、风格、颜色及卖点"
        minHeight={null}
        maxLength={400}
        wrapStyle={{ height: 76 }}
        value={description}
        onInput={e => setState({ description: e.target.value })}
      />
    </div>
    <div className="idea-mass-wrapper">
      <div className="title">选择灵感集<div style={{ flex: 1 }} /></div>
      {visibleWhalePick ? <div className="modes">
        <span className={classNames('mode', { active: mode === MODES.COLLECT })} onClick={() => setMode(MODES.COLLECT)}>采集</span>
        <span className={classNames('mode', { active: mode === MODES.PURCHASE })} onClick={() => setMode(MODES.PURCHASE)}>采买</span>
      </div> : null}
      {(visibleWhalePick && mode === MODES.PURCHASE) ? <Sku
        tags={tags}
        onClose={onClose}
        onChangeMainImage={onChangeMainImage}
        onAddTag={onAddTag}
        onDeleteTag={onDeleteTag}
        onSubmit={onJoin}
        itemId={currentViewBlog.imageGroupEntityId}
        itemInfo={{ ...itemDataDTO, mainUrl }}
      /> : <>
        <Input.Search
          wrapClassName="search"
          onChange={val => setState({ keyWords: val }, () => { fetchIdeaMassList(queryType, imageGroupEntityId, val) })}
          placeholder="搜索灵感集"
        />
        <div className="ins-tab-wrap">
          <span className={classNames('tab-item', { active: queryType === QUERY_TYPE.ALL })} onClick={() => onChangeTab(QUERY_TYPE.ALL, imageGroupEntityId, keyWords)}>全部</span>
          <span className={classNames('tab-item', { active: queryType === QUERY_TYPE.MY })} onClick={() => onChangeTab(QUERY_TYPE.MY, imageGroupEntityId, keyWords)}>我拥有的</span>
          <span className={classNames('tab-item', { active: queryType === QUERY_TYPE.COOP })} onClick={() => onChangeTab(QUERY_TYPE.COOP, imageGroupEntityId, keyWords)}>我协作的</span>
        </div>
        <InsList
          canCreateIdeaMass
          data={inspirationGroups}
          onChooseTaskClose={() => onClose()}
          onChooseTaskOk={() => onClose()}
          onCreatedInspiration={_onCreateInspiration}
          onAddOrRemove={_beforeJoin}
          loading={loading}
          onLoad={() => fetchIdeaMassList(queryType, imageGroupEntityId, keyWords, start)}
          isEnd={isEnd}
          isBatch={batchSelected?.length}
        />
      </> }
    </div>
  </div>
}

function ItemInfo({
  itemTitle,
  rootCategoryId,
  categoryId,
  shopName,
  itemId,
  price,
  platformName,
  categoryName,
  currency,
  imageGroupEntityId,
  userInfo = {}
}) {
  const categories = {}
  userInfo?.categories?.forEach((m) => { categories[m.first.id] = m.second })
  const rootName = userInfo?.categories?.find(m => m.first.id === rootCategoryId)?.first.name
  const name = categories[rootCategoryId]?.find(m => m.id === categoryId)?.name
  const UNIT = {
    USD: '$',
    CNY: '¥',
    GBP: '£'
  }
  return <div className="ins-add-inspiration-info-wrapper">
    <div className="item-name" onClick={() => itemId && link.toGoodDetail(imageGroupEntityId)}>{itemTitle}</div>
    <div className="shop-name-wrapper"><div>{shopName || platformName}</div><span>{rootName || categoryName}{name ? `-${name}` : ''}</span></div>
    <div className="price">{UNIT[currency] || '¥'}{(price / 100).toFixed(2)}</div>
  </div>
}
